/**
 * Returns the base URL for API calls
 * Priority: VITE_API_BASE env var > current page's host (with port 3000) > localhost:3000
 *
 * /api 경로를 apache reverse proxy로 처리하기 때문에 포트 번호 3000은 제외.
 */
export function getApiBaseUrl() {
  // Use current page's protocol and hostname with port 3000
  if (typeof window !== "undefined" && window.location) {
    const { protocol, hostname } = window.location;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return `${protocol}//${hostname}:3000`;
    } else {
      return `${protocol}//${hostname}`;
    }
  }

  // Fallback for non-browser environments
  return "http://localhost:3000";
}
